"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BFSHistoryWalk = void 0;
const HistoryWalk_1 = require("./HistoryWalk");
class BFSHistoryWalk extends HistoryWalk_1.HistoryWalk {
    next() {
        if (this.queue.length > 0) {
            const hash = this.dequeue();
            for (const succ of this.goFrom(hash)) {
                // if succ is in fragment.missing do not go there
                if (this.fragment.contents.has(succ)) {
                    this.enqueueIfNew(succ);
                }
            }
            const nextOp = this.fragment.contents.get(hash);
            if (nextOp === undefined) {
                throw new Error('Missing op history found while walking history fragment, probably includeInitial=true and direction=forward where chosen that are an incompatible pair');
            }
            return { value: nextOp, done: false };
        }
        else {
            return { done: true, value: undefined };
        }
    }
}
exports.BFSHistoryWalk = BFSHistoryWalk;
//# sourceMappingURL=BFSHistoryWalk.js.map